"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleTrigger = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var uuid_1 = require("uuid");
var pickBy_1 = tslib_1.__importDefault(require("lodash/pickBy"));
/**
 * @internal
 */
var BubbleTrigger = /** @class */ (function (_super) {
    tslib_1.__extends(BubbleTrigger, _super);
    function BubbleTrigger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            bubbleId: "bubble-" + uuid_1.v4(),
            isBubbleVisible: false,
        };
        _this.onClose = function () {
            _this.changeBubbleVisibility(false);
        };
        return _this;
    }
    BubbleTrigger.prototype.eventListeners = function () {
        return {};
    };
    BubbleTrigger.prototype.changeBubbleVisibility = function (active) {
        this.setState({ isBubbleVisible: active });
    };
    BubbleTrigger.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, eventsOnBubble = _b.eventsOnBubble, className = _b.className, tagName = _b.tagName, others = tslib_1.__rest(_b, ["children", "eventsOnBubble", "className", "tagName"]);
        var dataAttributes = pickBy_1.default(others, function (_, key) { return key.startsWith("data-"); });
        var classNames = classnames_1.default("gd-bubble-trigger", className, (_a = {},
            _a[this.state.bubbleId] = true,
            _a));
        var TagName = tagName;
        var BubbleElement;
        var WrappedTrigger;
        react_1.default.Children.map(children, function (child) {
            if (child) {
                if (child.type && child.type.identifier === "Bubble") {
                    BubbleElement = child;
                }
                else {
                    WrappedTrigger = child;
                }
            }
        });
        var bubbleProps = tslib_1.__assign(tslib_1.__assign({}, (eventsOnBubble ? this.eventListeners() : {})), { alignTo: "." + this.state.bubbleId, onClose: this.onClose });
        var BubbleOverlay = this.state.isBubbleVisible && BubbleElement ? react_1.default.cloneElement(BubbleElement, bubbleProps) : "";
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TagName, tslib_1.__assign({}, dataAttributes, this.eventListeners(), { className: classNames }), WrappedTrigger),
            BubbleOverlay));
    };
    BubbleTrigger.defaultProps = {
        className: "",
        children: false,
        eventsOnBubble: false,
        tagName: "span",
    };
    return BubbleTrigger;
}(react_1.default.PureComponent));
exports.BubbleTrigger = BubbleTrigger;
//# sourceMappingURL=BubbleTrigger.js.map